<div class="md:h-full flex flex-col justify-between relative">
  <form [formGroup]="form" class="grow overflow-auto h-full flex flex-col gap-2">
    @for (field of registerFields$ | async; track field.fieldId) {
      @if (form.contains(field.fieldId)) {
        <div class="px-3">
          <div class="flex gap-2 items-center">
            <button mat-icon-button (click)="toggleExpand(field.fieldId)">
              <mat-icon> @if (isExpanded(field.fieldId)) {
                keyboard_arrow_down
              } @else {
                chevron_right
              } </mat-icon>
            </button>
            <div>{{ field.fieldName }}</div>
          </div>

          @if (isExpanded(field.fieldId)) {
            <div class="pl-4">
              <div
                [innerHTML]="'catalog.facet_statistics.unique_values' | transloco: {value: getStats(field.fieldId)?.unique}"
                class="mb-1 text-xs text-gray-400"></div>

              <mat-radio-group [formControlName]="field.fieldId" class="flex flex-col">
                <mat-radio-button value="countvals">
                  {{ 'catalog.facet_statistics.with_value' | transloco: {count: getStats(field.fieldId)?.countvals} }}
                </mat-radio-button>
                <mat-radio-button value="missing">
                  {{ 'catalog.facet_statistics.without_value' | transloco: {count: getStats(field.fieldId)?.missing} }}
                </mat-radio-button>
              </mat-radio-group>
            </div>
          }
        </div>
      }
    }
  </form>
  <div class="p-3 border-top flex gap-2 justify-center items-center">
    <button (click)="onReset()" class="error-icon-button" mat-icon-button>
      <mat-icon>restart_alt</mat-icon>
    </button>
    <button (click)="onSearch()" mat-flat-button>
      <mat-icon>search</mat-icon>
      {{ facetItem?.statResultCount }}
    </button>
  </div>
</div>
